import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { FooterMode } from '@/store/ui';

export enum GroupOrderErrorPageType {
  NotFound = 'not-found',
  MaxParticipantCountReached = 'max-reached',
}

@Component({
  name: 'CmgGroupOrderError',
  beforeRouteLeave(to, from, next) {
    this.$services.ui.popFooterState();
    next();
  },
})
export default class CmgGroupOrderError extends Vue {
  get heading(): string {
    switch (this.$route.params.type) {
      case GroupOrderErrorPageType.NotFound:
        return 'THE GROUP ORDER IS NO LONGER AVAILABLE.';
      case GroupOrderErrorPageType.MaxParticipantCountReached:
        return 'THIS GROUP ORDER HAS REACHED ITS LIMIT.';
      default:
        return '';
    }
  }

  get subHeading(): string {
    switch (this.$route.params.type) {
      case GroupOrderErrorPageType.NotFound:
        return `But that doesn't mean you can't eat Chipotle...`;
      case GroupOrderErrorPageType.MaxParticipantCountReached:
        return `Contact your group's organizer if you feel you're being left out.`;
      default:
        return '';
    }
  }

  get sadAvocadoImgUrl() {
    return this.$appStore.state.cms.images.sadAvocado.default;
  }

  mounted() {
    this.$services.ui.pushFooterState({ mode: FooterMode.Micro });
    this.$services.order.resetPendingGroupOrder();
  }

  onClickGoHome(): void {
    this.$router.push({ name: Routes.Home });
  }
}
